<template>
  <FormField title="Brand name" v-model="brand.name" :required="true" placeholder="Enter your brand name" :error="getError('name')"/>
  <FormField title="Website" v-model="brand.website" :required="true" placeholder="Add your website link" :error="getError('website')"/>
  <FormField title="Brand description" v-model="brand.bio" placeholder="Describe your brand" :error="getError('bio')" componentType="textarea" rows="5"/>

  <h5 class="sub-title">Upload your logo</h5>
  <FormField ref="logoUploadComponent" note="1000px x 100px works best" :error="getError('logo')" componentType="upload" mode="custom" chooseLabel="Click here to add your logo" :fileLimit="1" :maxFileSize="10000000" accept="image/*" @select="selectLogo" @remove="onRemoveLogo" />

  <template v-if="props.showInstagram || props.showTiktok || props.showFacebook">
    <h5 class="sub-title">Connect your socials</h5>
    <FormField v-if="props.showInstagram" title="Instagram" v-model="brand.instagram" placeholder="Enter your username" :error="getError('instagram')" note="Don't add spaces or special characters (i.e. reebok)"/>
    <FormField v-if="props.showTiktok" title="TikTok" v-model="brand.tiktok" placeholder="Enter your username" :error="getError('tiktok')" note="Don't add spaces or special characters (i.e. reebok)"/>
    <FormField v-if="props.showFacebook" title="Facebook" v-model="brand.facebook" placeholder="Enter your username" :error="getError('facebook')" note="Don't add spaces or special characters (i.e. reebok)"/>
  </template>

</template>

<script setup>
import FormField from "../FormField";
import {watch, ref, onMounted} from "vue";
import {useVModel} from "@vueuse/core/index";
import {useFile} from "../../hooks/useFile";

const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  getError: {type: Function, required: true},
  modelValue: {type: Object, required: true},
  showInstagram: {type: Boolean,},
  showTiktok: {type: Boolean,},
  showFacebook: {type: Boolean,},
});

const {remoteToFile} = useFile();
const brand = useVModel(props, 'modelValue', emit);

const logoUploadComponent = ref();

onMounted(() => {
  syncLogo();
})

watch(() => brand.value, async ({ logo }) => {
  syncLogo();
}, {deep: true})

const syncLogo = async () => {
  const logo = brand.value?.logo;

  if (logo && !(logo instanceof File) && logoUploadComponent.value) {
    logoUploadComponent.value.component.files = [await remoteToFile(logo.url, logo.name)];
  }
}

const selectLogo = ({ files }) => {
  if (files.length) {
    brand.value.logo = files[0];
  }
}

const onRemoveLogo = () => {
  brand.value.logo = null;
  logoUploadComponent.value.component.files = [];
}

</script>

<style lang="scss" scoped>

</style>
